module.exports = __webpack_public_path__ + "static/media/medium-lite.5662845d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vehicles/medium-lite.png
// module id = 647
// module chunks = 27